import clsx from 'clsx';
import { Pagination, PaginationProps } from 'components/UI/V3/Pagination/Pagination';
import styles from 'components/UI/V3/Table/Table.module.scss';
import React from 'react';

type TableProps = React.ComponentProps<'table'> & {
    firstColumnFixed?: boolean;
    pagination?: PaginationProps;
    onPageChange?: (page: number) => void;
    onSizeChange?: (size: number) => void;
};

export const Table: React.FC<TableProps> = ({
    children,
    className,
    pagination,
    onPageChange,
    onSizeChange,
    firstColumnFixed,
    ...props
}) => {
    const ref = React.useRef<HTMLDivElement>(null);

    const [isScrolled, setIsScrolled] = React.useState(false);

    const handleScroll = React.useCallback((event: Event) => {
        setIsScrolled((event.target as HTMLDivElement).scrollLeft > 0);
    }, []);

    React.useEffect(() => {
        ref.current?.addEventListener('scroll', handleScroll);

        return () => {
            ref.current?.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);

    return (
        <div className={styles.root}>
            <div
                ref={ref}
                className={styles.scrollWrapper}
            >
                <table
                    className={clsx(styles.table, className, {
                        [styles.scrolled]: isScrolled,
                        [styles.firstColumnFixed]: firstColumnFixed
                    })}
                    {...props}
                >
                    {children}
                </table>
            </div>

            {pagination && (
                <Pagination
                    {...pagination}
                    onPageChange={onPageChange}
                    onSizeChange={onSizeChange}
                    className={styles.pagination}
                />
            )}
        </div>
    );
};
